
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 14","fill":"#007AFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.333 2.222v8.89H2.223v-8.89h11.11zM14.444 0H1.111C.5 0 0 .5 0 1.111v11.111c0 .611.5 1.111 1.111 1.111h13.333c.612 0 1.112-.5 1.112-1.11V9.298a.4.4 0 01.682-.283l3.08 3.079a.4.4 0 00.682-.283V1.522a.4.4 0 00-.683-.284l-3.079 3.08a.4.4 0 01-.682-.284V1.111C15.556.5 15.056 0 14.444 0z"}})])
          )
        }
      }
    